import { configureStore } from "@reduxjs/toolkit";
import storeImported from "./store";

export const store = configureStore(storeImported);

(window as any).getState = store.getState;
